import * as React from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { TceFireIntegrationMetaFieldProps } from "../interface";

const TceFireIntegrationMetaField = ({
    optionsSelectedHandler,
    featuresMetaData,
}: TceFireIntegrationMetaFieldProps) => {
    const letUserDisconnect =
        featuresMetaData.TCE_FIRE_INTEGRATION?.letUserDisconnect ?? true;

    return (
        <div style={{ margin: "10px 10px" }}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={Boolean(letUserDisconnect)}
                        onChange={(event) =>
                            optionsSelectedHandler(event.target.checked)
                        }
                    />
                }
                label="Allow user disconnect"
            />
        </div>
    );
};

export default TceFireIntegrationMetaField;
